import { Checkbox as AntCheckbox } from 'antd';
import type { InputProps } from './types';

export function Checkbox({ field, value, onChange }: InputProps) {
  return (
    <AntCheckbox
      checked={!!value}
      onChange={(e) => onChange(e.target.checked)}
      disabled={field.disabled}
    >
      {field.label}
    </AntCheckbox>
  );
}
